var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Surface',{attrs:{"component":"th","backgroundColor":"#dfe3e7","padding":_vm.padding},on:{"click":_vm.sort}},[_c('div',{class:[
      ("header header--align-" + _vm.textAlign),
      _vm.sortable ? 'header--sortable' : ''
    ]},[_c('Typography',{attrs:{"component":"h6"}},[_vm._t("default")],2),(_vm.tippy)?_c('div',{staticClass:"tip-head-table"},[_c('Info',{directives:[{name:"tippy",rawName:"v-tippy",value:({
          placement: 'bottom',
          arrow: true,
          arrowType: 'round',
          offset: '0, 10'
        }),expression:"{\n          placement: 'bottom',\n          arrow: true,\n          arrowType: 'round',\n          offset: '0, 10'\n        }"}],attrs:{"content":_vm.tippy,"height":20,"width":20,"fill":"#10222D"}})],1):_vm._e(),(_vm.sortable)?_c('div',{class:[
        'header__sort',
        _vm.sortKey === _vm.sortField ? ("header__sort--" + _vm.sortOrder) : ''
      ]},[_c('Arrow',{attrs:{"fill":_vm.sortKey === _vm.sortField ? '#233443' : '#92A2B0',"width":"8","height":"5","direction":_vm.sortKey === _vm.sortField && _vm.sortOrder === 'DESC' ? 'up' : 'down'}})],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }